import * as Sentry from '@sentry/react';

import {
  LoginFormValues,
  loginRequest,
} from '~/contexts/UserAuthProvider/requests/login';
import { logoutRequest } from '~/contexts/UserAuthProvider/requests/logout';

// Constants
export const AUTH_CHANGE_TRIGGER = 'authChangeTrigger';

// Helpers
export const login = async (formValues: LoginFormValues) => {
  await loginRequest(formValues);
  // Tell other tabs to log the user in as well
  window.localStorage.setItem(AUTH_CHANGE_TRIGGER, new Date().toISOString());
  window.location.reload();
};

export const logout = async () => {
  try {
    // Log user out by asking the server to clear the `finleySession` cookie
    await logoutRequest();
    // Tell other tabs to log the user our as well
    window.localStorage.setItem(AUTH_CHANGE_TRIGGER, new Date().toISOString());
    // Reload page to force app to re-initialize and re-evaluate user auth state
    window.location.assign('/auth/login');
  } catch (error) {
    Sentry.captureException(
      error instanceof Error ? error : new Error('Failed to log user out'),
    );
  }
};
